import BusinessIcon from '@mui/icons-material/Business';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import Page from 'modules/Page';
import * as constants from './constants';

const ClientsPage = lazyWithSuspense(() => import('./ClientsPage'));

const page: Page = {
  title: constants.TITLE,
  mainMenuConfig: {
    group: 'Admin',
    iconComponent: BusinessIcon,
  },
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage({ WrappedPage: ClientsPage, titleFn: () => i18n._(constants.TITLE) }),
  admin: true,
};

export default page;
